import { SelectItem } from "primeng/api";

export const DEFAULT_OPTION: SelectItem[] = [
  { label: 'Tous', value: 'all' },

];
